module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "search__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    ref: "input",
    staticClass: "search__input",
    attrs: {
      "id": "search-input",
      "type": "text",
      "placeholder": "Search or create",
      "spellcheck": "false",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.isSearchFocused = true
      },
      "blur": [function($event) {
        _vm.isSearchFocused = false
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      }, _vm.updateQuery],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch($event)
      }
    }
  }), _vm._v(" "), _c('search-info', {
    attrs: {
      "resultsCount": _vm.filteredNotes.length,
      "queryLength": _vm.query.length,
      "selected": _vm.activeNote != null,
      "searching": _vm.isSearchFocused,
      "renaming": _vm.renamingId != null,
      "editing": _vm.editingId != null
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    staticClass: "search__add",
    on: {
      "click": _vm.onCreate
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "search__results"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b1651b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactsSearch/Index.vue
// module id = 2116
// module chunks = 0